var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bitmap Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.855,0 L10.9444975,0 C16.3872637,-9.99819933e-16 20.7994975,4.41223379 20.7994975,9.855 C20.7994975,15.2977662 16.3872637,19.71 10.9444975,19.71 L9.855,19.71 C4.41223379,19.71 6.66546622e-16,15.2977662 0,9.855 C-6.66546622e-16,4.41223379 4.41223379,9.99819933e-16 9.855,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Supervisor-desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bitmap-Copy-2",
    transform: "translate(0.743719, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E7304B",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("text", {
    id: "!",
    mask: "url(#mask-2)",
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: 1.19209276e-9,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 8.73174874,
    y: 13.91625
  }, "!"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.37d410872dba863fc84285734ad5f9a8.svg";
export { ForwardRef as ReactComponent };